import {
  getUCAN
} from '~api/ucan'

export const state = () => ({
  ucan: {
    ucan_link: 'https://ucan.moe.edu.tw/Account/Login.aspx'
  }
})

export const getters = {
  ucanGetter: state => state.ucan
}

export const actions = {
  async getUCANUrl ({
    commit
  }) {
    const ucan = await getUCAN()

    commit('setUCAN', ucan)

    return ucan
  }
}

export const mutations = {
  setUCAN (state, payload) {
    state.ucan = payload
  }
}
